{
    "401": "Usuario y/o contraseña incorrectos",
    "default": "Error inesperado"
}
